import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) {}

  /** Permite el acceso solo si hay sesión; si no, redirige al login. */
  private hasSession(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      this.router.navigate(['/auth/login']);
      return false;
    }
    return true;
  }

  canActivate(): boolean {
    return this.hasSession();
  }

  // Se ejecuta al navegar entre páginas hijas del dashboard (sin recargar):
  // si la sesión desaparece, también redirige al login.
  canActivateChild(): boolean {
    return this.hasSession();
  }
}
